S.product = {
    config: {
        cartHash: null,
    },
    elements: {
        /** @var show response layer */
        $showResponse: null,
    },

    /** @var */
    product_qty: 1,
    $addToCard: null,

    init()
    {
    },

    start()
    {
        // init buy event
        this.initBuyButtonEvent();
    },

    /**
     *
     */
    initBuyButtonEvent()
    {
        const $cartCounter = $('.m-cart-count');

        this.$addToCart = this.$module.find('.m-add-to-cart-link');

        this.$addToCart.on('click', (e) =>
        {
            e.preventDefault();

            const $target = $(e.currentTarget),
                data = {
                    action: 'woocommerce_ajax_add_to_cart',
                    product_id: $target.data('product_id'),
                    product_sku: $target.data('product_sku'),
                    quantity: this.product_qty,
                };

            this.elements.$showResponse.removeClass('is-hidden').addClass('m-loading');

            jQuery.ajax({
                type: 'POST',
                url: woocommerce_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
                headers: {
                    'X-WC-Store-API-Nonce': this.config.cartHash,
                },
                data: data,
                complete: () =>
                {
                    S.delayed(`product-add-to-cart-hint-${this.id}`, 1500, () =>
                    {
                        this.elements.$showResponse.addClass('is-hidden').removeClass('m-loading');
                        $cartCounter.addClass('m-changed');
                    });

                    S.delayed(`scale-cart-count-${this.id}`, 2500, () =>
                    {
                        $cartCounter.removeClass('m-changed');
                    });
                },
                success: (response) =>
                {
                    // if error return to page
                    if (response.error && response.product_url)
                    {
                        // return to product url
                        window.location = response.product_url;
                        return;
                    }

                    // cart count
                    const value = $cartCounter.eq(0).text();

                    if (value.length)
                    {
                        $cartCounter.text(parseInt(value, 10) + this.product_qty);
                    }
                    else
                    {
                        $cartCounter.text(this.product_qty);
                    }
                    //
                    // jQuery(document).trigger('added_to_cart', [response.fragments, response.cart_hash, $target]);
                },
                error: (error) =>
                {
                    this.elements.$showResponse.addClass('is-hidden').removeClass('m-loading');
                },
            });

            return false;
        });

    },
};
